import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    console.log('I am alerted again!');
  }
}
